import { Suspense, lazy, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';

import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import Theme from './theme/Theme';
import LoadingPage from './pages/LoadingPage';
import ExpiredPage from './pages/ExpiredPage';
import LandingAceptacionDatos from './pages/Landing/LandingAceptacionDatos';

const CategoriaProductos = lazy(() => import('src/pages/CategoriaProductos'));
const GrupoProductos = lazy(() => import('src/pages/CategoriaProductos/GrupoProductos'));
const FinProcesoInfo = lazy(() => import('src/pages/NewFinCompra/FinProcesoInfo'));
const NewFinCompra = lazy(() => import('src/pages/NewFinCompra'));
const NewPreviewProducto = lazy(() => import('src/pages/PreviewProducto/PreviewProducto'));
const GenerarUrlPTP = lazy(() => import('src/pages/Redirects/GenerarUrlPTP'));
const PtpPagoSuscripcion = lazy(() => import('src/pages/Redirects/PtpPagoSuscripcion'));
const PtpPagoSuscripcionFromCorreo = lazy(() => import('src/pages/Redirects/PtpPagoSuscripcionFromCorreo'));
const ErrorPage = lazy(() => import('src/pages/ErrorPage'));
const ExtraDataForm = lazy(() => import('src/pages/ExtraDataForm'));
const HomePage = lazy(() => import('src/pages/Home'));
const Home = lazy(() => import('src/pages/Home/Home2'));
const IngresarPoliza = lazy(() => import('src/pages/IngresarPoliza'));
const Pagador = lazy(() => import('src/pages/Pagador'));
const FirmarPolizaEvicertia = lazy(() => import('src/pages/IngresarPoliza/FirmarPolizaEvicertia'));
const FirmarCertificado = lazy(() => import('src/pages/IngresarPoliza/FirmarCertificado'));
const Login = lazy(() => import('src/pages/Login'));
const CamibarPass = lazy(() => import('src/pages/Login/CamibarPass'));
const VerificarTokenPago = lazy(() => import('src/pages/NewPaginaCompra/VerificarTokenPago'));
const NotFound = lazy(() => import('src/pages/NotFound'));
const PtpMontoMinimoFromCorreo = lazy(() => import('src/pages/Redirects/PtpMontoMinimoFromCorreo'));
const PtpPagoUnico = lazy(() => import('src/pages/Redirects/PtpPagoUnico'));
const PtpPrimerPagoSuscripcion = lazy(() => import('src/pages/Redirects/PtpPrimerPagoSuscripcion'));
const RegistroTitularPage = lazy(() => import('src/pages/Resgistro'));
const ListadoPagos = lazy(() => import('src/pages/ListadoPagos/ListadoPagos'));
const CambioSuscripcionPtp = lazy(() => import('src/pages/CambioSuscripcionPtp'));
const FinCambioSuscripcion = lazy(() => import('src/pages/CambioSuscripcionPtp/FinCambioSuscripcion'));
const Components = lazy(() => import('src/pages/ComponentsPage'));
const Landing = lazy(() => import('./pages/Landing/Landing'));
const LandingExpress = lazy(() => import('./pages/LandingExpress/LadingExpress'));
const DatosTitular = lazy(() => import('src/pages/RegistroTitular/RegistroTitular'));
const DatosBeneficiario = lazy(() => import('./pages/DatosBeneficiario'));
const ResumenPlanes = lazy(() => import('./pages/ResumenPlanes/ResumenPlanes'));
const PaginaCompra = lazy(() => import('./pages/PaginaCompra'));
const PaginaResumen = lazy(() => import('./pages/PaginaCompra/PaginaResumen'));
const HistorialPagosPtp = lazy(() => import('./pages/HistorialPagos/HistorialPagosPtp'));
const ValidarNuvei = lazy(() => import('src/pages/ValidarNuvei'));

const LayoutRouteTheme = ({ component: Component, h100 = false, oauth2 = false, ...rest }) => (
  <Route
    component={() => {
      const Componente = () => {
        useEffect(() => {
          ReactPixel.pageView();
          ReactGA.send('pageview');
          ReactGA.send({ hitType: 'pageview', page: window?.location?.pathname });
        }, []);
        return <Component />;
      };

      return (
        <div className={`container-xl ${h100 ? 'h-100' : ''}`}>
          <Theme>
            <Componente />
          </Theme>
        </div>
      );
    }}
    {...rest}
  />
);

const HasAuthorization = ({ component: Component, h100 = false, ...rest }) => (
  <Route
    component={() => {
      const Componente = () => {
        useEffect(() => {
          ReactPixel.pageView();
          ReactGA.send('pageview');
          ReactGA.send({ hitType: 'pageview', page: window?.location?.pathname });
        }, []);
        return <Component />;
      };

      const urlBase = 'http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/frontend/web/index.php?r=site';
      const validarToken = `${urlBase}/validar-token`;

      return (
        <div className={`container-xl ${h100 ? 'h-100' : ''}`}>
          <Theme>
            <Componente />
          </Theme>
        </div>
      );
    }}
    {...rest}
  />
);

// ReactPixel.trackCustom('ingresos', { currency: "USD", value: 30.00 })

const Routes = () => {
  return (
    <Suspense fallback={<LoadingWrapper loading={true} />}>
      <Switch>
        {/*V4 Routes */}
        <LayoutRouteTheme exact path="/home/:idUsuario/:parametros" component={Home} />
        <LayoutRouteTheme exact path="/newHome/:idCotizacion" component={HomePage} />
        <LayoutRouteTheme exact path="/preview/:idCotizacion/:idProducto" component={NewPreviewProducto} />
        <LayoutRouteTheme exact path="/error/:idCotizacion" component={ErrorPage} />
        <LayoutRouteTheme exact path="/newRegistro/:idCotizacion" component={RegistroTitularPage} />
        {/******************************* URLS flujo express ***********************************/}
        <LayoutRouteTheme exact path="/datosTitular/:idCotizacion" component={DatosTitular} />
        <LayoutRouteTheme exact path="/datosTitular/:idCotizacion/:update" component={DatosTitular} />
        <LayoutRouteTheme exact path="/datosBeneficiario/:idCotizacion" component={DatosBeneficiario} />
        <LayoutRouteTheme exact path="/seleccionarPlan/:idCotizacion" component={ResumenPlanes} />
        <LayoutRouteTheme path="/expiredPage" component={ExpiredPage} />
        {/*******************************    ------------    ***********************************/}
        <LayoutRouteTheme exact path="/newRegistro/:idCotizacion/:update" component={RegistroTitularPage} />
        <LayoutRouteTheme exact path="/newPaginaCompra/:idCotizacion" component={PaginaCompra} />
        <LayoutRouteTheme exact path="/paginaResumen/:idCotizacion" component={PaginaResumen} />
        <LayoutRouteTheme exact path="/paginaResumen/:idCotizacion/:estadoPago" component={PaginaResumen} />
        <LayoutRouteTheme exact path="/paginaPago/:idCotizacion" component={PaginaResumen} />
        {/* <LayoutRouteTheme exact path="/paginaPago/:idCotizacion" component={PaginaPago} /> */}

        {/* V3 LayoutRoutes */}
        {/* http://localhost:3000/login/plataforma/empresa/canal */}

        {/*Paginas del nuevo diseño */}
        {/* <LayoutRouteTheme exact path="/embed/categoriaProductos/:idUsuario/:parametros" component={CategoriaProductos} /> */}
        <LayoutRouteTheme exact path="/categoriaProductos/:idUsuario/:parametros" component={CategoriaProductos} />

        <LayoutRouteTheme exact path="/embed/categoriaProductos/:idUsuario/:idPrecotizacion/:parametros" component={CategoriaProductos} />
        {/* <LayoutRouteTheme exact path="/categoriaProductos/:idUsuario/:idPrecotizacion/:parametros" component={CategoriaProductos} /> */}

        <LayoutRouteTheme exact path="/grupoProductos/:idUsuario/:parametros" component={GrupoProductos} />
        <LayoutRouteTheme path="/landing/:canal/:aseguradora/:canalComercial/:grupo" component={Landing} />
        <LayoutRouteTheme path="/landingExpress/:canal/:aseguradora/:canalComercial/:grupo/:token/:base64?" component={LandingExpress} />
        {/* Landig aceptacion datos */}
        <LayoutRouteTheme path="/landing/aceptacion-datos" component={LandingAceptacionDatos} />
        {/* Landig aceptacion datos */}
        {/* empAplica = canalComercial */}
        <LayoutRouteTheme exact path="/login/:canal/:empBroker/:empAplica" component={Login} h100 />
        <LayoutRouteTheme exact path="/login/:canal/:empBroker/:empAplica/newpass" component={CamibarPass} h100 />
        <LayoutRouteTheme exact path="/finproceso/:idCotizacion" component={NewFinCompra} />
        <LayoutRouteTheme exact path="/finprocesoinfo/:idCotizacion/:result" component={FinProcesoInfo} />
        <LayoutRouteTheme exact path="/ingresarPoliza/:idCotizacion" component={IngresarPoliza} />
        <LayoutRouteTheme exact path="/pagador/:idCotizacion" component={Pagador} />
        <LayoutRouteTheme exact path="/firmarPolizaEvicertia/:idCotizacion/:idPoliza" component={FirmarPolizaEvicertia} />
        <LayoutRouteTheme exact path="/firmarCertificado/:idCotizacion" component={FirmarCertificado} />
        <LayoutRouteTheme exact path="/verificarTokenPago/:idCotizacion/:idPoliza?" component={VerificarTokenPago} />
        {/* ESTA ES LA PAGINA FINAL */}
        <LayoutRouteTheme exact path="/newFinCompra/:idCotizacion" component={NewFinCompra} />
        <LayoutRouteTheme exact path="/newFinCompra/paypal/:idCotizacion" component={NewFinCompra} />
        <LayoutRouteTheme exact path="/newFinCompra/stripe/:idCotizacion" component={NewFinCompra} />
        <LayoutRouteTheme exact path="/newFinCompra/cybersource/:idCotizacion" component={NewFinCompra} />
        <LayoutRouteTheme exact path="/finCompra/:idCotizacion/" component={PtpPagoUnico} />
        {/* ESTA PAGINA SIRVE PARA HACER LA VALIDACION DEL PAGO, NO SE PUEDE CAMBIAR PORQUE EN EL MIDDLEWARE SE USAR CON ESE NOMBRE :/ */}
        <LayoutRouteTheme exact path="/place-to-pay/:idCotizacion/" component={GenerarUrlPTP} />
        <LayoutRouteTheme exact path="/final-cotizacion/" component={PtpPagoUnico} />
        <LayoutRouteTheme exact path="/fin-suscripcion/:idCotizacion/:idSuscripcion" component={PtpPagoSuscripcion} />
        <LayoutRouteTheme exact path="/primer-pago-suscripcion/:idCotizacion/:idSuscripcion" component={PtpPrimerPagoSuscripcion} />
        <LayoutRouteTheme exact path="/fin-suscripcion-correo/:idCotizacion" component={PtpPagoSuscripcionFromCorreo} />
        <LayoutRouteTheme exact path="/ptp-monto-minimo-suscripcion/:idCotizacion/:idSuscripcion" component={PtpMontoMinimoFromCorreo} />
        <LayoutRouteTheme exact path="/extra-data-form/:idCotizacion" component={ExtraDataForm} />
        <LayoutRouteTheme exact path="/listado-pago/:idCotizacion/:empresa" component={ListadoPagos} />
        <LayoutRouteTheme exact path="/cambiosuscripcionptp/:idCotizacion" component={CambioSuscripcionPtp} />
        <LayoutRouteTheme exact path="/fin-cambiosuscripcion/:idCotizacion/:idSuscripcion" component={FinCambioSuscripcion} />
        <LayoutRouteTheme exact path="/historial-pagos-ptp/:empresa" component={HistorialPagosPtp} />
        <LayoutRouteTheme exact path="/validarNuvei/:idCotizacion" component={ValidarNuvei} />
        <LayoutRouteTheme path="/components" component={Components} />
        <LayoutRouteTheme path="/landing/:idUsuario/:parametros" component={Landing} />
        <LayoutRouteTheme path="/loading" component={LoadingPage} />
        <LayoutRouteTheme path="/*" component={NotFound} />
      </Switch>
    </Suspense>
  );
};
export default Routes;
